import React from 'react'
import { Routes,Route } from 'react-router-dom'
import Home from './Home'
import AboutUs from '../../AboutPage/AboutUs/AboutUs'
import ContactUs from '../../ContactUsPage/ContactUs/ContactUs'
import Shop from '../../ShopPage/Shop'
import Cart from '../../CartPage/Cart'
import Category from '../../CategoryPage/Category'
import Onoffer from '../../OnofferPage/Onoffer'


const Rout = ({shopProducts, setShopProducts, detail, view, close, setClose, cart, setCart, addtocart}) => {
  return (
    <>
     <Routes>
        <Route path='/' element={<Home detail={detail} view={view} close={close} setClose={setClose} addtocart={addtocart}/>}/>
        <Route path='/about' element={<AboutUs/>}/>
        <Route path='/contact' element={<ContactUs/>}/>
        <Route path='/shop' element={<Shop shopProducts={shopProducts} setShopProducts={setShopProducts} detail={detail} view={view} close={close} setClose={setClose} addtocart={addtocart}/>}/>
        <Route path='/cart' element={<Cart cart={cart} setCart={setCart}/>}/>  
        <Route path='/shop/shop-by-categories' element={<Category shopProducts={shopProducts} setShopProducts={setShopProducts} detail={detail} view={view} close={close} setClose={setClose} addtocart={addtocart}/>}/> 
        <Route path='/shop/on-offer' element={<Onoffer/>}/>
     </Routes>
    </>
  )
}

export default Rout